<div *let="isWorkspaceDetailsLoading$ | async as loading">
  <div class="row-with-title">
    <div class="col-title">
      <span class="link-like" (click)="goToWorkspaces()">{{
        'workspaces.myWorkspaces' | transloco
      }}</span>
      @if (workspaceDetails && !loading) {
        >
        {{ workspaceDetails.name }}
      }
    </div>

    <div class="col-add-button" *let="isAddingWorkspaceDocuments$ | async as addingDocuments">
      <app-button
        class="after-control"
        icon="add"
        [type]="btnTypes.Flat"
        label="{{ 'workspaces.addDocuments' | transloco }}"
        (onClick)="addDocuments()"
        [disabled]="!!loading || !!addingDocuments || !canAddDocumentsToWorkspace"
        [size]="btnSizes.Basic"
      ></app-button>
    </div>
  </div>

  @if (!loading) {
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-6">
        <app-workspace-documents></app-workspace-documents>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-6">
        <app-clause-variance-analysis-box></app-clause-variance-analysis-box>
      </div>
    </div>
  }
</div>
